import { Component } from "react";
import LocaleUtil from "../uidispatcherapi/LocaleUtil";
import CountryUtil from "../uidispatcherapi/CountryUtil";
export class NextCmsCookieDisclaimer extends Component<Record<PropertyKey, never>> {
	componentDidMount() {
		const siteCoreUrl =
			CountryUtil.getOptionalConfig()?.siteCoreUrl ?? "https://authors-dev2-sc.metro.md/data/apps/metro";
		const script = document.createElement("script");
		const locale = LocaleUtil.getLocale();

		if (locale.includes("en")) {
			script.src = siteCoreUrl + "?sc_device=webcomponent&components=cookie%20disclaimer";
		} else {
			script.src = siteCoreUrl + "?sc_device=webcomponent&components=cookie%20disclaimer&sc_lang=" + locale;
		}

		if (document.head != null) {
			document.head.appendChild(script);
		}
	}

	render() {
		return <cms-cookie-disclaimer />;
	}
}
